const URL = "https://raw.githubusercontent.com/Qingquan-Li/files/main/TravelPhotos/";

export const AmericaNewYorkNYC = [
  URL + "America/NewYork/NYC/1.jpg",
  URL + "America/NewYork/NYC/2.jpg",
  URL + "America/NewYork/NYC/3.jpg",
  URL + "America/NewYork/NYC/4.jpg",
  URL + "America/NewYork/NYC/5.jpg",
  URL + "America/NewYork/NYC/6.jpg",
];
export const AmericaNewYorkTimesSquare = [
  URL + "America/NewYork/TimesSquare/1.jpg",
  URL + "America/NewYork/TimesSquare/2.jpg",
  URL + "America/NewYork/TimesSquare/3.jpg",
];
export const AmericaNewYorkCentralPark = [
  URL + "America/NewYork/CentralPark/1.jpg",
  URL + "America/NewYork/CentralPark/2.jpg",
  URL + "America/NewYork/CentralPark/3.jpg",
  URL + "America/NewYork/CentralPark/4.jpg",
  URL + "America/NewYork/CentralPark/5.jpg",
  URL + "America/NewYork/CentralPark/6.jpg",
  URL + "America/NewYork/CentralPark/7.jpg",
  URL + "America/NewYork/CentralPark/8.jpg",
  URL + "America/NewYork/CentralPark/9.jpg",
];
export const AmericaNewYorkWallStreet = [
  URL + "America/NewYork/WallStreet/1.jpg",
  URL + "America/NewYork/WallStreet/2.jpg",
  URL + "America/NewYork/WallStreet/3.jpg",
];
export const AmericaNewYorkStatueOfLiberty = [
  URL + "America/NewYork/StatueOfLiberty/1.jpg",
  URL + "America/NewYork/StatueOfLiberty/2.jpg",
  URL + "America/NewYork/StatueOfLiberty/3.jpg",
];
export const AmericaNewYorkTheMET = [
  URL + "America/NewYork/TheMET/1.jpg",
  URL + "America/NewYork/TheMET/2.jpg",
  URL + "America/NewYork/TheMET/3.jpg",
];
export const AmericaNewYorkBrooklynBotanicGarden = [
  URL + "America/NewYork/BrooklynBotanicGarden/1.jpg",
  URL + "America/NewYork/BrooklynBotanicGarden/2.jpg",
  URL + "America/NewYork/BrooklynBotanicGarden/3.jpg",
];
export const AmericaNewYorkTaconicStatePark = [
  URL + "America/NewYork/TaconicStatePark/1.jpg",
  URL + "America/NewYork/TaconicStatePark/2.jpg",
  URL + "America/NewYork/TaconicStatePark/3.jpg",
];

export const AmericaCaliforniaStateRoute1 = [
  URL + "America/California/StateRoute1/1.jpg",
  URL + "America/California/StateRoute1/2.jpg",
  URL + "America/California/StateRoute1/3.jpg",
  URL + "America/California/StateRoute1/4.jpg",
  URL + "America/California/StateRoute1/5.jpg",
  URL + "America/California/StateRoute1/6.jpg",
  URL + "America/California/StateRoute1/7.jpg",
  URL + "America/California/StateRoute1/8.jpg",
  URL + "America/California/StateRoute1/9.jpg",
  URL + "America/California/StateRoute1/10.jpg",
  URL + "America/California/StateRoute1/11.jpg",
  URL + "America/California/StateRoute1/12.jpg",
];
export const AmericaCaliforniaLosAngeles = [
  URL + "America/California/LosAngeles/1.jpg",
  URL + "America/California/LosAngeles/2.jpg",
  URL + "America/California/LosAngeles/3.jpg",
  URL + "America/California/LosAngeles/4.jpg",
  URL + "America/California/LosAngeles/5.jpg",
  URL + "America/California/LosAngeles/6.jpg",
];
export const AmericaCaliforniaSanFrancisco = [
  URL + "America/California/SanFrancisco/1.jpg",
  URL + "America/California/SanFrancisco/2.jpg",
  URL + "America/California/SanFrancisco/3.jpg",
  URL + "America/California/SanFrancisco/4.jpg",
  URL + "America/California/SanFrancisco/5.jpg",
  URL + "America/California/SanFrancisco/6.jpg",
  URL + "America/California/SanFrancisco/7.jpg",
  URL + "America/California/SanFrancisco/8.jpg",
  URL + "America/California/SanFrancisco/9.jpg",
];
export const AmericaCaliforniaSiliconValley = [
  URL + "America/California/SiliconValley/1.jpg",
  URL + "America/California/SiliconValley/2.jpg",
  URL + "America/California/SiliconValley/3.jpg",
  URL + "America/California/SiliconValley/4.jpg",
  URL + "America/California/SiliconValley/5.jpg",
  URL + "America/California/SiliconValley/6.jpg",
];
export const AmericaCaliforniaPinnaclesNationalPark = [
  URL + "America/California/PinnaclesNationalPark/1.jpg",
  URL + "America/California/PinnaclesNationalPark/2.jpg",
  URL + "America/California/PinnaclesNationalPark/3.jpg",
  URL + "America/California/PinnaclesNationalPark/4.jpg",
  URL + "America/California/PinnaclesNationalPark/5.jpg",
  URL + "America/California/PinnaclesNationalPark/6.jpg",
];

export const AmericaMassachusettsBashBishFallsStatePark = [
  URL + "America/Massachusetts/BashBishFallsStatePark/1.jpg",
  URL + "America/Massachusetts/BashBishFallsStatePark/2.jpg",
  URL + "America/Massachusetts/BashBishFallsStatePark/3.jpg",
  URL + "America/Massachusetts/BashBishFallsStatePark/4.jpg",
  URL + "America/Massachusetts/BashBishFallsStatePark/5.jpg",
  URL + "America/Massachusetts/BashBishFallsStatePark/6.jpg",
];

export const AmericaNewJerseyStairwayToHeaven = [
  URL + "America/NewJersey/StairwayToHeaven/1.jpg",
  URL + "America/NewJersey/StairwayToHeaven/2.jpg",
  URL + "America/NewJersey/StairwayToHeaven/3.jpg",
  URL + "America/NewJersey/StairwayToHeaven/4.jpg",
  URL + "America/NewJersey/StairwayToHeaven/5.jpg",
  URL + "America/NewJersey/StairwayToHeaven/6.jpg",
];

export const AmericaWashingtonDCCapital = [
  URL + "America/WashingtonDC/Capital/1.jpg",
  URL + "America/WashingtonDC/Capital/2.jpg",
  URL + "America/WashingtonDC/Capital/3.jpg",
  URL + "America/WashingtonDC/Capital/4.jpg",
  URL + "America/WashingtonDC/Capital/5.jpg",
  URL + "America/WashingtonDC/Capital/6.jpg",
  URL + "America/WashingtonDC/Capital/7.jpg",
  URL + "America/WashingtonDC/Capital/8.jpg",
  URL + "America/WashingtonDC/Capital/9.jpg",
];
export const AmericaWashingtonDCSmithsonianNationalZoo = [
  URL + "America/WashingtonDC/SmithsonianNationalZoo/1.jpg",
  URL + "America/WashingtonDC/SmithsonianNationalZoo/2.jpg",
  URL + "America/WashingtonDC/SmithsonianNationalZoo/3.jpg",
  URL + "America/WashingtonDC/SmithsonianNationalZoo/4.jpg",
  URL + "America/WashingtonDC/SmithsonianNationalZoo/5.jpg",
  URL + "America/WashingtonDC/SmithsonianNationalZoo/6.jpg",
];

export const AmericaConnecticut = [
  URL + "America/Connecticut/1.jpg",
  URL + "America/Connecticut/2.jpg",
  URL + "America/Connecticut/3.jpg",
  URL + "America/Connecticut/4.jpg",
  URL + "America/Connecticut/5.jpg",
  URL + "America/Connecticut/6.jpg",
];

export const MalaysiaKualaLumpur = [
  URL + "Malaysia/KualaLumpur/1.jpg",
  URL + "Malaysia/KualaLumpur/2.jpg",
  URL + "Malaysia/KualaLumpur/3.jpg",
  URL + "Malaysia/KualaLumpur/4.jpg",
  URL + "Malaysia/KualaLumpur/5.jpg",
  URL + "Malaysia/KualaLumpur/6.jpg",
];
export const MalaysiaMelaka = [
  URL + "Malaysia/Melaka/1.jpg",
  URL + "Malaysia/Melaka/2.jpg",
  URL + "Malaysia/Melaka/3.jpg",
];
export const MalaysiaKotaKinabalu = [
  URL + "Malaysia/KotaKinabalu/1.jpg",
  URL + "Malaysia/KotaKinabalu/2.jpg",
  URL + "Malaysia/KotaKinabalu/3.jpg",
];

export const ThailandChiangMai = [
  URL + "Thailand/ChiangMai/1.jpg",
  URL + "Thailand/ChiangMai/2.jpg",
  URL + "Thailand/ChiangMai/3.jpg",
];
export const ThailandChiangRai = [
  URL + "Thailand/ChiangRai/1.jpg",
  URL + "Thailand/ChiangRai/2.jpg",
  URL + "Thailand/ChiangRai/3.jpg",
];
export const ThailandPattaya = [
  URL + "Thailand/Pattaya/1.jpg",
  URL + "Thailand/Pattaya/2.jpg",
  URL + "Thailand/Pattaya/3.jpg",
];
export const ThailandBangkok = [
  URL + "Thailand/Bangkok/1.jpg",
  URL + "Thailand/Bangkok/2.jpg",
  URL + "Thailand/Bangkok/3.jpg",
];

export const ChinaGuangdong = [
  URL + "China/Guangdong/1.jpg",
  URL + "China/Guangdong/2.jpg",
  URL + "China/Guangdong/3.jpg",
  URL + "China/Guangdong/4.jpg",
  URL + "China/Guangdong/5.jpg",
  URL + "China/Guangdong/6.jpg",
  URL + "China/Guangdong/7.jpg",
  URL + "China/Guangdong/8.jpg",
  URL + "China/Guangdong/9.jpg",
];
// export const ChinaGuangxi = [
//   URL + "China/Guangxi/1.jpg",
// ];
export const ChinaYunnan = [
  URL + "China/Yunnan/1.jpg",
  URL + "China/Yunnan/2.jpg",
  URL + "China/Yunnan/3.jpg",
  URL + "China/Yunnan/4.jpg",
  URL + "China/Yunnan/5.jpg",
  URL + "China/Yunnan/6.jpg",
];
export const ChinaHongKong = [
  URL + "China/HongKong/1.jpg",
  URL + "China/HongKong/2.jpg",
  URL + "China/HongKong/3.jpg",
];
export const ChinaMacao = [
  URL + "China/Macao/1.jpg",
  URL + "China/Macao/2.jpg",
  URL + "China/Macao/3.jpg",
];